module.exports = __webpack_public_path__ + "static/media/anatomia.31c3bc83.png";